import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import React from 'react'
import CropComponents from '../General/CropComponents'

function ModalCropImage({ open, onClose, dataImg, onSaveCrop, croppedImage, setCroppedImage }) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='md'>
      <DialogTitle>
        <h4>Crop Image</h4>
      </DialogTitle>
      <DialogContent>
        <CropComponents
          image={dataImg}
          croppedImage={croppedImage}
          setCroppedImage={setCroppedImage}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant='contained' color='info'>
          Back
        </Button>
        <Button
          disabled={croppedImage ? false : true}
          onClick={() => onSaveCrop(croppedImage)}
          variant='contained'
          color='primary'
        >
          Save Photo
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalCropImage